var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDetailedView(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 19 11.327",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #428bca;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun_104336_cc",
    transform: "translate(-4.925 -23.1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_111",
    "data-name": "Path 111",
    className: "cls-1",
    d: "M23.862,28.5A10.932,10.932,0,0,0,5,28.5a.479.479,0,0,0,0,.527,11.689,11.689,0,0,0,1.815,2.323,10.654,10.654,0,0,0,7.614,3.076,10.839,10.839,0,0,0,9.429-5.4A.581.581,0,0,0,23.862,28.5Zm-9.429,4.894A9.736,9.736,0,0,1,6.08,28.774a9.862,9.862,0,0,1,16.706,0A9.783,9.783,0,0,1,14.433,33.394Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_112",
    "data-name": "Path 112",
    className: "cls-1",
    d: "M36.191,32.5a3.691,3.691,0,1,0,3.691,3.691A3.709,3.709,0,0,0,36.191,32.5Zm0,6.328a2.637,2.637,0,1,1,2.637-2.637A2.638,2.638,0,0,1,36.191,38.828Z",
    transform: "translate(-21.758 -7.417)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_113",
    "data-name": "Path 113",
    className: "cls-1",
    d: "M44.082,42.5a1.582,1.582,0,1,0,1.582,1.582A1.594,1.594,0,0,0,44.082,42.5Zm0,2.109a.527.527,0,1,1,.527-.527A.522.522,0,0,1,44.082,44.609Z",
    transform: "translate(-29.649 -15.308)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDetailedView);
export default __webpack_public_path__ + "static/media/detailed_view.05de4036bbb4f39c699294b257b6dfc4.svg";
export { ForwardRef as ReactComponent };